import React, { Component } from "react";
import $ from "jquery";
import DataTable from "datatables.net";
import { withRouter } from "react-router";
import { ToastContainer } from "react-toastr";
import axios from "../utils/axios";
import { errorClass, showError } from "../utils/form";
import { getUserInfo } from "../utils/auth";
import { formatDate } from "../utils/format";

function checkNumberFormat(number) {
  return (
    parseFloat(number) - Math.floor(parseFloat(number)) === 0.5 ||
    parseFloat(number) - Math.floor(parseFloat(number)) === 0.0
  );
}

function isInteger(number) {
  return parseFloat(number) - Math.floor(parseFloat(number)) === 0.0;
}

const initialErrors = {
  project_id: "true",
  workstation_id: "true",
  workMinutes: "true",
  otMinutes: "true",
  nonPerformMinutes: "true",
  non_perform_type_id: "true",
};

class EntryModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workDate: "",
      name: getUserInfo().name,
      errors: initialErrors,
      workStations: [],
      projects: [],
      nonPerformTypes: [],
    };
    $.DataTable = DataTable;
    this.state.id = this.props.id;
    this._handleChange = this._handleChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  getProjects = async () => {
    try {
      const response = await axios()
        .get(`/projects/actives`, {
          headers: {
            authorization: "jwt " + localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          return res.data;
        });
      this.setState({ projects: response });
    } catch (err) {
      console.log(err);
    }
  };

  getWorkStations = async () => {
    try {
      const response = await axios()
        .get(`/workstations/actives`)
        .then((res) => {
          return res.data;
        });
      this.setState({ workStations: response });
    } catch (err) {
      console.log(err);
    }
  };

  getNonPerformTypes = async () => {
    try {
      const response = await axios()
        .get(`/nonperformtypes`)
        .then((res) => {
          return res.data;
        });
      this.setState({ nonPerformTypes: response });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    this.getProjects();
    this.getWorkStations();
    this.getNonPerformTypes();
  };

  _handleChange(event) {
    const { id, value } = event.target;
    if (id === "nonPerformMinutes" || id === "non_perform_type_id") {
      let object = {
        workstation_id: null,
        project_id: null,
        workMinutes: 0,
        otMinutes: 0,
        nonPerformMinutes:
          id === "nonPerformMinutes"
            ? value
            : this.props.info.nonPerformMinutes,
        non_perform_type_id:
          id === "non_perform_type_id"
            ? value
            : this.props.info.non_perform_type_id,
      };
      this.props.onChange(object);
    } else {
      let object = {
        workstation_id:
          id === "workstation_id" ? value : this.props.info.workstation_id,
        project_id: id === "project_id" ? value : this.props.info.project_id,
        workMinutes: id === "workMinutes" ? value : this.props.info.workMinutes,
        otMinutes: id === "otMinutes" ? value : this.props.info.otMinutes,
        nonPerformMinutes: 0,
        non_perform_type_id: null,
      };
      this.props.onChange(object);
    }
  }

  async _handleSubmit(e) {
    e.preventDefault();
    if (this.validateForm()) {
      console.info("Valid Form");
      this.props.submitTimesheetLine();
      $("#close-button").click();
    } else {
      console.error("Invalid Form");
    }
  }
  checkNotEmpty = () => {};

  validateForm() {
    let valid = true;
    let {
      project_id,
      workstation_id,
      workMinutes,
      otMinutes,
      nonPerformMinutes,
      non_perform_type_id,
    } = this.props.info;
    let isWorkExceed =
      this.props.total.totalWorkHour + +workMinutes + +nonPerformMinutes > 8
        ? true
        : false;
    let isOtExceed = this.props.total.totalOt + +otMinutes > 16 ? true : false;
    let theCombination = { workstation_id, project_id };
    let isTheCombinationExisted =
      this.props.modalType === "add" &&
      this.props.existCombination.filter(
        (item) =>
          item.workstation_id === theCombination.workstation_id &&
          item.project_id === theCombination.project_id
      ).length > 0;
    let errors;
    if (nonPerformMinutes || non_perform_type_id) {
      errors = {
        nonPerformMinutes: nonPerformMinutes
          ? isInteger(nonPerformMinutes)
            ? isWorkExceed
              ? "Total work and non-perform hour per time sheet must not exceed 8 hours!"
              : ""
            : "Non perform hour must be integer only"
          : "Please fill in non-perform hour",
        non_perform_type_id: non_perform_type_id
          ? ""
          : "Please select a non-perform type",
        project_id: "",
        workstation_id: "",
        workMinutes: "",
        otMinutes: "",
      };
    } else {
      errors = {
        nonPerformMinutes: "",
        non_perform_type_id: "",
        project_id: project_id
          ? isTheCombinationExisted
            ? "The combination between workstation and project already exists"
            : ""
          : "Please select a project!",
        workstation_id: workstation_id
          ? isTheCombinationExisted
            ? "The combination between workstation and project already exists"
            : ""
          : "Please select a work station!",
        workMinutes: workMinutes
          ? checkNumberFormat(workMinutes)
            ? isWorkExceed
              ? "Total work and non-perform hour per time sheet must not exceed 8 hours!"
              : ""
            : "Hour must be either .5 or integer only"
          : otMinutes
          ? ""
          : "Please fill in either work or ot hour or both",
        otMinutes: otMinutes
          ? checkNumberFormat(otMinutes)
            ? isOtExceed
              ? "Total ot hour per time sheet must not exceed 16 hours!"
              : ""
            : "Hour must be either .5 or integer only"
          : workMinutes
          ? ""
          : "Please fill in either work or ot hour or both",
      };
    }
    this.setState({ errors });
    Object.values(errors).forEach((val) => val !== "" && (valid = false));
    return valid;
  }

  render() {
    const { errors } = this.state;
    return (
      <div style={{ maxWidth: "75%" }} className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              {this.props.modalType === "edit"
                ? "Edit Time Record"
                : "Create Time Record"}
            </h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <ToastContainer
              ref={(ref) => (this.container = ref)}
              className="toast-top-right"
            />
            {/* Main content */}
            <section className="content mx-2">
              <form className="form-horizontal">
                <div className="row mx-0">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-6">
                            <div className="form-group row">
                              <label
                                htmlFor="name"
                                className="col-sm-2 col-form-label"
                              >
                                Name
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="name"
                                  placeholder="Name"
                                  value={this.props.empName}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend">
                                  <span className="input-group-text">
                                    <i className="far fa-calendar-alt" />
                                  </span>
                                </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="date"
                                  value={formatDate(this.props.workDate)}
                                  disabled
                                />
                              </div>
                              {/* /.input group */}
                            </div>
                            {/* /.form group */}
                          </div>
                        </div>
                      </div>
                      {/* form start */}

                      <div className="card-body">
                        <div className="form-group row">
                          <label
                            htmlFor="workstation_id"
                            className="col-sm-2 col-form-label"
                          >
                            Work Station
                          </label>
                          <div className="col-sm-10">
                            <select
                              id="workstation_id"
                              className={errorClass(errors.workstation_id)}
                              value={this.props.info.workstation_id || ""}
                              onChange={this._handleChange}
                            >
                              <option
                                style={{ display: "none" }}
                                disabled
                                value=""
                              >
                                Please select your work station...
                              </option>
                              {this.state.workStations.map((item) => {
                                return (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                            {showError(errors.workstation_id)}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="project"
                            className="col-sm-2 col-form-label"
                          >
                            Project
                          </label>
                          <div className="col-sm-10">
                            <select
                              id="project_id"
                              className={errorClass(errors.project_id)}
                              value={this.props.info.project_id || ""}
                              onChange={this._handleChange}
                            >
                              <option
                                style={{ display: "none" }}
                                disabled
                                value=""
                              >
                                Please select a project...
                              </option>
                              {this.state.projects.map((item) => {
                                return (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                            {showError(errors.project_id)}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="hour"
                            className="col-sm-2 col-form-label"
                          >
                            Work Hour
                          </label>
                          <div className="col-sm-10">
                            <input
                              id="workMinutes"
                              type="text"
                              className={errorClass(errors.workMinutes)}
                              value={this.props.info.workMinutes}
                              onChange={this._handleChange}
                              disabled={this.props.isHoliday}
                            />
                            {showError(errors.workMinutes)}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="hour"
                            className="col-sm-2 col-form-label"
                          >
                            Overtime
                          </label>
                          <div className="col-sm-10">
                            <input
                              id="otMinutes"
                              type="text"
                              className={errorClass(errors.otMinutes)}
                              value={this.props.info.otMinutes}
                              onChange={this._handleChange}
                            ></input>
                            {showError(errors.otMinutes)}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="hour"
                            className="col-sm-2 col-form-label"
                          >
                            NP Hour
                          </label>
                          <div className="col-sm-2">
                            <input
                              id="nonPerformMinutes"
                              type="text"
                              className={errorClass(errors.nonPerformMinutes)}
                              value={this.props.info.nonPerformMinutes}
                              onChange={this._handleChange}
                              disabled={this.props.isHoliday}
                            ></input>
                            {showError(errors.nonPerformMinutes)}
                          </div>
                          <label
                            htmlFor="workHour"
                            className="col-sm-2 col-form-label text-center"
                          >
                            NP Type
                          </label>
                          <div className="col-sm-6">
                            <select
                              id="non_perform_type_id"
                              value={this.props.info.non_perform_type_id || ""}
                              className={errorClass(errors.non_perform_type_id)}
                              onChange={this._handleChange}
                              disabled={this.props.isHoliday}
                            >
                              <option
                                style={{ display: "none" }}
                                disabled
                                value=""
                              >
                                Please select a NP type...
                              </option>
                              {this.state.nonPerformTypes.map((item) => {
                                return (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                            {showError(errors.non_perform_type_id)}
                          </div>
                        </div>
                        <div className="form-group row"></div>
                      </div>
                      {/* /.card-body */}
                      <div className="card-footer">
                        <button
                          onClick={(e) => {
                            this._handleSubmit(e);
                          }}
                          type="submit"
                          className="btn btn-success float-right"
                        >
                          Save
                        </button>
                        <button
                          data-dismiss="modal"
                          className="btn btn-danger float-right mx-3"
                          onClick={() => {
                            this.setState({ errors: initialErrors });
                          }}
                          id="close-button"
                        >
                          Cancel
                        </button>
                      </div>
                      {/* /.card-footer */}
                    </div>
                    {/* /.card */}
                  </div>
                  {/* /.col */}
                </div>
                {/* /.row */}
              </form>
            </section>
          </div>
        </div>
        {/* /.modal-content */}
      </div>
    );
  }
}

export default withRouter(EntryModal);
